import {deviceData} from "../../dataInterface/deviceDetailInterface";
import {salesDataByMonthInterface} from "../../dataInterface/salesDataByMonthInterface";


interface fetchUserReducer {
    type:string
    payload:salesDataByMonthInterface
}

export default (state = null, action:fetchUserReducer) => {
    switch (action.type) {
        case "SALES_DATA":
            return action.payload;
        default:
            return state;
    }
};
